module.exports = __webpack_public_path__ + "img/shot_img112002.12ea0133.gif";